(function(){
  var HEDEF=["hazir_fiyat","en_yeniler","koleksiyonluk"];
  var BEKLE={hazir_fiyat:2100, en_yeniler:2400, koleksiyonluk:2700};
  var GECIS=340;
  function kur(sec, ad){
    var grid=sec.querySelector(".grid.product-grid") || sec.querySelector("ul.grid");
    if(!grid || grid.dataset.tpMarquee) return;
    var kartlar=Array.prototype.slice.call(grid.children);
    if(kartlar.length < 3) return;
    grid.dataset.tpMarquee="1";
    var sarmal=document.createElement("div"); sarmal.className="tp-marquee";
    var track=document.createElement("div"); track.className="tp-marquee__track";
    grid.parentNode.insertBefore(sarmal, grid);
    sarmal.appendChild(track);
    kartlar.forEach(function(k){ track.appendChild(k); });
    kartlar.forEach(function(k){
      var kopya=k.cloneNode(true);
      kopya.setAttribute("aria-hidden","true");
      Array.prototype.forEach.call(kopya.querySelectorAll("a,button,input,select"),function(e){ e.setAttribute("tabindex","-1"); });
      track.appendChild(kopya);
    });
    grid.remove();

    var adet=kartlar.length, i=0, dokunmaBitis=0;
    var suru=false, basX=0, basY=0, kayX=0, temelX=0, yon=null;

    function offsetOf(idx){
      var c=track.children[idx];
      return c ? (c.offsetLeft - track.children[0].offsetLeft) : 0;
    }
    function konum(idx, animasyonlu){
      var hedef=offsetOf(idx);
      if(!animasyonlu){
        track.classList.add("tp-nojump");
        track.style.transform="translate3d(-"+hedef+"px,0,0)";
        void track.offsetWidth;
        track.classList.remove("tp-nojump");
      } else {
        track.style.transform="translate3d(-"+hedef+"px,0,0)";
      }
    }
    function git(hedefIndex){
      if(hedefIndex < 0){
        i = adet; konum(i,false);
        hedefIndex = adet - 1;
      }
      i = hedefIndex;
      konum(i, true);
      if(i >= adet){ setTimeout(function(){ i=0; konum(0,false); }, GECIS+40); }
    }
    function uygunMu(){
      if(document.hidden) return false;
      if(suru) return false;
      if(Date.now() < dokunmaBitis) return false;
      try{ if(sarmal.matches(":hover")) return false; }catch(e){}
      var r=sarmal.getBoundingClientRect();
      return r.top < (window.innerHeight||0) && r.bottom > 0;
    }
    setInterval(function(){ if(uygunMu()) git(i+1); }, BEKLE[ad]||2300);

    // --- parmakla kaydirma ---
    sarmal.addEventListener("touchstart",function(e){
      if(e.touches.length!==1) return;
      suru=true; yon=null;
      basX=e.touches[0].clientX; basY=e.touches[0].clientY;
      temelX=-offsetOf(i); kayX=temelX;
      dokunmaBitis=Date.now()+3000;
      track.classList.add("tp-nojump");
    },{passive:true});
    sarmal.addEventListener("touchmove",function(e){
      if(!suru || e.touches.length!==1) return;
      var dx=e.touches[0].clientX-basX, dy=e.touches[0].clientY-basY;
      if(yon===null) yon = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
      if(yon!=="x") return;
      kayX=temelX+dx;
      track.style.transform="translate3d("+kayX+"px,0,0)";
      dokunmaBitis=Date.now()+3000;
    },{passive:true});
    function birak(){
      if(!suru) return;
      suru=false;
      track.classList.remove("tp-nojump");
      var fark=kayX-temelX;
      var esik=40;
      if(fark < -esik) git(i+1);
      else if(fark > esik) git(i-1);
      else konum(i, true);
      dokunmaBitis=Date.now()+3000;
    }
    sarmal.addEventListener("touchend",birak,{passive:true});
    sarmal.addEventListener("touchcancel",birak,{passive:true});

    // --- fare ile surukleme (masaustu) ---
    sarmal.addEventListener("mousedown",function(e){
      suru=true; yon="x"; basX=e.clientX; temelX=-offsetOf(i); kayX=temelX;
      sarmal.classList.add("tp-suruklu");
      track.classList.add("tp-nojump");
      e.preventDefault();
    });
    window.addEventListener("mousemove",function(e){
      if(!suru) return;
      kayX=temelX+(e.clientX-basX);
      track.style.transform="translate3d("+kayX+"px,0,0)";
    });
    window.addEventListener("mouseup",function(){
      if(!suru) return;
      sarmal.classList.remove("tp-suruklu");
      birak();
    });

    window.addEventListener("resize",function(){ konum(i,false); });
  }
  function calistir(){
    HEDEF.forEach(function(ad){
      var sec=document.querySelector("#shopify-section-"+ad) || document.querySelector("[id$=__"+ad+"]");
      if(sec) kur(sec, ad);
    });
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",calistir); else calistir();
  document.addEventListener("shopify:section:load",calistir);
})();